<template>
  <div class="company-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <div v-if="tabs[activeTab].id === 'users'" :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
      <Table
        :checkbox="false"
        :removeTableLines="true"
        :loading="loading"
        :headers="usersHeaders"
        :items="users"
        :add-row-button="false"
        :action-buttons="false"
      />
    </div>
    <div v-if="tabs[activeTab].id === 'roles'" :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
      <Table
        :checkbox="false"
        :removeTableLines="true"
        :loading="loading"
        :headers="rolesHeaders"
        :items="roles"
        :add-row-button="false"
        :action-buttons="false"
      />
    </div>
    <div v-if="tabs[activeTab].id === 'workspaces'" :style="{'height': 'calc(100% - 60px)', 'margin-top': '21px'}">
      <Table
        :checkbox="false"
        :removeTableLines="true"
        :loading="loading"
        :headers="workspacesHeaders"
        :items="workspaces"
        :add-row-button="false"
        :action-buttons="false"
      />
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from '@/newComponents/_Molecules/Table';

export default {
  name: "CompanySpecificInfo",

  components: {
    Tabs,
    Table,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },

    roles: {
      type: Array,
      required: true,
    },

    workspaces: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      loading: false,
    }
  },

  computed: {
    usersHeaders() {
      return [
        {
          text: this.$i18n.t('Name'),
          varName: "first_name",
          editable: false,
        },
        {
          text: this.$i18n.t('Username'),
          varName: "username",
          editable: false,
        },
        {
          text: this.$i18n.t('Email'),
          varName: "email",
          editable: false,
        },
      ]
    },

    workspacesHeaders() {
      return [
        {
          text: this.$i18n.tc('Label', 1),
          varName: "wp_label",
          editable: false,
        },
        {
          text: this.$i18n.t('PlanName'),
          varName: "wp_plan_name",
          editable: false,
        },
        {
          text: this.$i18n.t('Phase'),
          varName: "wp_status",
          editable: false,
        },
      ]
    },

    rolesHeaders() {
      return [
        {
          text: this.$i18n.t('Name'),
          varName: "name",
          editable: false,
        }
      ]
    },

    tabs() {
      return [
        {
          id: 'users',
          label: this.$i18n.tc("User", 2),
        },
        {
          id: 'roles',
          label: this.$i18n.tc("Role", 2),
        },
        {
          id: 'workspaces',
          label: this.$i18n.tc("Workspace", 2),
        },
      ]
    },
  },
}
</script>

<style scoped>
.company-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 71%;
}

</style>


// WEBPACK FOOTER //
// src/newComponents/SystemManagement/Companies/CompanySpecificInfo.vue